export function DashboardPage() {
  return (
    <div>
      <h1 className="text-2xl font-bold">Dashboard</h1>
      <p className="mt-2 text-muted-foreground">
        Welcome to the admin dashboard.
      </p>
    </div>
  );
}

export default DashboardPage;
